<ngx-app-bar
  class="w-100"
  [title]="'توثیق دارایی'"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
/>

<div class="d-flex flex-wrap w-100 container">
  <div class="detail mt-big">
    <img
      src="./wealth-assets/svg/collateral-detail.svg"
      alt=""
    />

    <div class="w-100 mt-big title">توثیق دارایی چیست؟</div>

    <div class="w-100 px-medium">
      <div class="stepper">
        @for (item of stepItems; track $index) {
          <div class="step">
            <div class="circle"></div>
            <span>
              {{ item }}
            </span>
          </div>
        }
      </div>
    </div>

    <div class="w-100 mt-big px-medium">
      <ngx-callout
        [title]="'نکات مهم'"
        [mode]="'multiple'"
        [messages]="calloutMessages"
      />
    </div>
  </div>

  <div class="button-container">
    <div class="w-100 px-medium">
      <ngx-button
        [style]="'fill'"
        [fullWidth]="true"
        (clickHandler)="continue()"
        [size]="'medium'"
        [buttonId]="'COLLATERAL_REGISTER'"
        [disabled]="isLoading"
        [isLoading]="isLoading"
      >
        شروع!
      </ngx-button>
    </div>
  </div>
</div>
